const getters = {
  menuList: state => {
    // todo searchResultをコンポーネントに返すように変更
    return state.searchResult.items
  },
  searchResult: state => {
    return state.searchResult
  },
  insertionOrderList: state => {
    return state.insertionOrderList
  },
  advertiserList: state => {
    return state.advertiserList
  },
}

export default getters
